<template>
  <div>
    <b-form-file
      :id="id"
      v-model="internalValue"
      :drop-placeholder="dropPlaceholder"
      :accept="accept"
      :placeholder="placeholder"
      :state="state"
      :browse-text="browseText"
      :required="required"
      :disabled="disabled"
      :multiple="multiple"
      @change="onFileChange"
      v-on="$listeners"
    />
    <div v-if="state === false && invalidFeedback" class="invalid-feedback d-block">
      {{ invalidFeedback }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CustomFormFile",
  props: {
    value: File,
    id: String,
    dropPlaceholder: String,
    accept: String,
    placeholder: String,
    maxSize: {
      type: Number,
      default: 50 * 1024 * 1024 // 50 Mo
    },
    browseText: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: null,
      invalidFeedback: null,
      internalValue: this.value
    }
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.size > this.maxSize) {
        this.state = false;
        this.invalidFeedback = "Le fichier est trop volumineux (max 50 Mo).";
        this.internalValue = null;
        event.target.value = null;
        this.$emit('file-invalid', { reason: 'too-large', file });
        this.$emit('preview', null);
      } else if (file) {
        this.state = null;
        this.invalidFeedback = null;
        this.internalValue = file;
        this.$emit('file-valid', file);

        const reader = new FileReader();
        reader.onload = (e) => {
          this.$emit('preview', e.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.$emit('preview', null);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/b122/editFields/CustomFormFile.vue